var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('zf-value',[_vm._v(_vm._s(_vm.valueFormatted))]),(_vm.unit !== null)?[_c('span',[_vm._v(" ")]),_c('zf-unit',[_vm._v(_vm._s(_vm.unit))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }